// src/modules/app-views/leads/pages/Document/tabs/RecordTab/LeadAdditionalInfoCard.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Descriptions, Empty } from 'antd';
import translateX from 'utils/translateX';
import { useDocumentContext } from 'components/core/DocumentProvider';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const LeadAdditionalInfoContent = ({ lead: leadProp }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data: leadFromContext } = useDocumentContext();
  const lead = leadProp !== undefined ? leadProp : leadFromContext;

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const raw = lead?.customData;
  const hasData = raw && typeof raw === 'object' && Object.values(raw).some(hasValue);

  // Build Descriptions items dynamically — only entries with meaningful values
  const items = hasData
    ? Object.entries(raw)
        .filter(([, value]) => hasValue(value))
        .map(([key, value]) => ({
          key,
          label: key,
          children: formatValue(value),
        }))
    : [];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  if (!hasData || items.length === 0) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={translateX('no_additional_info')}
      />
    );
  }

  return (
    <Descriptions
      bordered
      size="small"
      column={1}
      items={items}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default LeadAdditionalInfoContent;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function hasValue(value) {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (typeof value === 'boolean') return value === true;
  return true;
}

function formatValue(value) {
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}
